/**
 * Zepto Field Translator
 * Replaces text content injected by Zepto scripts based on current locale.
 * Uses native event 'pplrAppInitiated' to trigger translation.
 */

const ZeptoTranslations = {
    // --- OPTIONS & HEADERS ---
    "Gebetsteppich personalisieren?": { "fr": "Personnaliser le tapis ?", "en": "Personalize prayer rug?" },
    "Gebetsteppich": { "fr": "Tapis de prière", "en": "Prayer Rug" },
    "Suche einen Teppich aus": { "fr": "Choisis un tapis", "en": "Choose a rug" },
    "Teppich": { "fr": "Tapis", "en": "Rug" },

    // --- PERSONALIZATION ---
    "Personalisierung - 1. Name": { "fr": "Personnalisation - 1er Prénom", "en": "Personalization - 1st Name" },
    "Personalisierung - 2. Name": { "fr": "Personnalisation - 2ème Prénom", "en": "Personalization - 2nd Name" },
    "Name 1": { "fr": "Prénom 1", "en": "Name 1" },
    "Name 2": { "fr": "Prénom 2", "en": "Name 2" },
    "Name": { "fr": "Prénom", "en": "Name" },
    "+ 2. Name": { "fr": "+ 2ème Prénom", "en": "+ 2nd Name" },
    "Zeichen links": { "fr": "caractères restants", "en": "chars left" },

    "Farbe des Namens": { "fr": "Couleur du prénom", "en": "Name Color" },
    "Suche eine Farbe aus": { "fr": "Choisis une couleur", "en": "Choose a color" },

    "Symbolen": { "fr": "Symboles", "en": "Symbols" },
    "Position des Symbols": { "fr": "Position du symbole", "en": "Symbol Position" },
    "Am Ende": { "fr": "À la fin", "en": "At the end" },
    "Am Anfang": { "fr": "Au début", "en": "At the beginning" },
    "Zwischen den beiden Namen": { "fr": "Entre les deux prénoms", "en": "Between both names" },

    "Expressanfertigung": { "fr": "Confection Express", "en": "Express Production" },
    "Deine Bestellung wird am nächsten Tag versandfertig gemacht und innerhalb von 1–2 Werktagen verschickt!": {
        "fr": "Ta commande sera préparée le lendemain et expédiée sous 1 à 2 jours ouvrés !",
        "en": "Your order will be ready the next day and shipped within 1-2 business days!"
    },

    // --- PRODUCTS ---
    "Gebetskette": { "fr": "Tasbih", "en": "Prayer Beads" },
    "Suche eine Gebetskette aus": { "fr": "Choisis un Tasbih", "en": "Choose prayer beads" },
    "Misköl": { "fr": "Musc", "en": "Musk Oil" },
    "Suche ein Parfum aus": { "fr": "Choisis un parfum", "en": "Choose a perfume" },
    "Parfümöl für Männer": { "fr": "Parfum pour Homme", "en": "Perfume for Men" },
    "Parfümöl für Frauen": { "fr": "Parfum pour Femme", "en": "Perfume for Women" },

    "Quran mit deutscher Übersetzung": { "fr": "Coran (Traduction Allemande)", "en": "Quran (German Translation)" },
    "Suche einen Quran aus": { "fr": "Choisis un Coran", "en": "Choose a Quran" },
    "Arabischer Quran": { "fr": "Coran Arabe", "en": "Arabic Quran" },
    "Quran": { "fr": "Coran", "en": "Quran" },
    "Das Buch ist \"Juz' Amma\" & enthält die kürzesten Suwar (Kapitel) des Korans.": {
        "fr": "Ce livre est \"Juz' Amma\" et contient les sourates les plus courtes du Coran.",
        "en": "This book is \"Juz' Amma\" and contains the shortest Surahs of the Quran."
    },

    "Schlüsselanhänger": { "fr": "Porte-clés", "en": "Keychain" },
    "Suche ein Produkt aus": { "fr": "Choisis un modèle", "en": "Choose a model" },

    "Siwak": { "fr": "Siwak", "en": "Miswak" },
    "Nicht Inklusive": { "fr": "Non inclus", "en": "Not Included" },
    "Inklusive": { "fr": "Inclus", "en": "Included" },

    "Gebetsmütze": { "fr": "Bonnet de prière", "en": "Prayer Cap" },
    "Keine": { "fr": "Non inclus", "en": "None" },

    "200 Bittgebete": { "fr": "200 Invocations", "en": "200 Duas" },
    "Buch": { "fr": "Livre", "en": "Book" },

    "Füge die passende": { "fr": "Ajoute la", "en": "Add the matching" },
    "Gebetskleidung": { "fr": "Tenue de prière", "en": "Prayer Outfit" },
    "Ein Set aus Hijab und Rock aus angenehmem Stoff, erhältlich in Einheitsgröße": {
        "fr": "Un ensemble Hijab et Jupe en tissu agréable, taille unique",
        "en": "A set of Hijab and Skirt made of pleasant fabric, available in one size"
    },

    // --- COLORS & OPTIONS ---
    "Schwarz": { "fr": "Noir", "en": "Black" },
    "Pastellrosa": { "fr": "Rose pastel", "en": "Pastel Pink" },
    "Silbergrau": { "fr": "Gris argenté", "en": "Silver Grey" },
    "Midnightblue": { "fr": "Bleu nuit", "en": "Midnight Blue" },
    "Dunkelgrün": { "fr": "Vert foncé", "en": "Dark Green" },
    "Dunkelgrau": { "fr": "Gris", "en": "Dark Grey" },
    "Pastellblau": { "fr": "Bleu pastel", "en": "Pastel Blue" },
    "Brownie": { "fr": "Marron", "en": "Brownie" },
    "Pastellbeige": { "fr": "Beige pastel", "en": "Pastel Beige" },
    "Schneeweiß": { "fr": "Blanc neige", "en": "Snow White" },
    "Gold": { "fr": "Doré", "en": "Gold" },
    "Hellrosa": { "fr": "Rose clair", "en": "Light Pink" },
    "Dunkelblau": { "fr": "Bleu foncé", "en": "Dark Blue" },
    "Khakigrün": { "fr": "Kaki", "en": "Khaki Green" },
    "Grau": { "fr": "Gris", "en": "Grey" },
    "Weinrot": { "fr": "Bordeaux", "en": "Burgundy" },
    "Weiß": { "fr": "Blanc", "en": "White" },
    "Weißgold": { "fr": "Or blanc", "en": "White Gold" },
    "Schwarzgold": { "fr": "Or noir", "en": "Black Gold" },
    "Roségold": { "fr": "Or rose", "en": "Rose Gold" },
    "Nude": { "fr": "Nude", "en": "Nude" },
    "Pastellgrau": { "fr": "Gris pastel", "en": "Pastel Grey" },
    "Königsblau": { "fr": "Bleu roi", "en": "Royal Blue" },
    "Rosa": { "fr": "Rose", "en": "Pink" },
    "Silbergold": { "fr": "Argent d'Or", "en": "Silver Gold" },
    "für Frau": { "fr": "pour Femme", "en": "for Women" },
    "für Mann": { "fr": "pour Homme", "en": "for Men" },

    // --- SYMBOLS & EXTRAS ---
    "Herz": { "fr": "Cœur", "en": "Heart" },
    "Infinity": { "fr": "Infini", "en": "Infinity" },
    "Mond": { "fr": "Lune", "en": "Moon" },
    "Stern": { "fr": "Étoile", "en": "Star" },
    "QURAN": { "fr": "CORAN", "en": "QURAN" },
    "30.Teil": { "fr": "30ème Partie", "en": "Part 30" },
    " dazu": { "fr": "", "en": "" }, // Remove " dazu" as verb is translated
    " hinzu": { "fr": "", "en": "" }, // Remove " hinzu"

    // --- NEW PHRASES ---
    "Bitte nur einen Namen eingeben": { "fr": "Entre un seul prénom", "en": "Please enter only one name" },
    "Bitte geben Sie hier den zweiten Namen ein": { "fr": "Entre le deuxième prénom ici", "en": "Enter the second name here" },
    "Ort des Symbols": { "fr": "Emplacement du symbole", "en": "Symbol Location" },
    "Füge eine passende": { "fr": "Ajoute un", "en": "Add a matching" },
    "Füge ein": { "fr": "Ajoute un", "en": "Add a" },
    "Füge einen": { "fr": "Ajoute un", "en": "Add a" },
    "Füge das passende": { "fr": "Ajoute le/la assorti(e)", "en": "Add the matching" },
    "Bittgebetbuch": { "fr": "Livre d'invocations", "en": "Dua Book" },
    "Dies ist der edle und vollständige Quran in arabischer Sprache": {
        "fr": "Ceci est le Noble Coran complet en langue arabe",
        "en": "This is the noble and complete Quran in Arabic"
    },
    "Quranbuch": { "fr": "Livre du Coran", "en": "Quran Book" },
    "Parfümöl": { "fr": "Musc", "en": "Perfume Oil" },

    // --- SPECIFIC UPSELL SENTENCES ---
    "Füge die passende 👸🏼- Gebetskleidung dazu": {
        "fr": "Ajoute la tenue de prière assortie 👸🏼",
        "en": "Add the matching prayer outfit for women 👸🏼"
    },
    "Füge das passende Parfum dazu": {
        "fr": "Ajoute le musc assorti",
        "en": "Add the matching perfume"
    },
    "Füge das passende Misköl dazu": {
        "fr": "Ajoute le musc assorti",
        "en": "Add the matching musk"
    },
    // Variation for Parfümöl (Perfume Oil) with various suffixes/emojis
    "Füge das passende Parfümöl hinzu🧴": {
        "fr": "Ajoute le musc assorti 🧴",
        "en": "Add the matching perfume 🧴"
    },
    "Füge das passende Parfümöl dazu🧴": {
        "fr": "Ajoute le musc assorti 🧴",
        "en": "Add the matching perfume 🧴"
    },
    "Füge das passende Parfümöl hinzu": {
        "fr": "Ajoute le musc assorti",
        "en": "Add the matching perfume"
    },

    "dazu": { "fr": "", "en": "" }, // Catch-all for lingering "dazu"

    // --- KEYCHAIN SLOGANS (Optional - Keeping titles but ensuring keys exist) ---
    // If user wants these translated, they can update here. For now keeping them as identifiers mostly.
    //"Best Dad In The Dunya": { "fr": "Meilleur Papa de la Dunya", "en": "Best Dad In The Dunya" },
    //"Best Mom In The Dunya": { "fr": "Meilleure Maman de la Dunya", "en": "Best Mom In The Dunya" },
    //"Sister in deen": { "fr": "Sœur en Deen", "en": "Sister in deen" }
};

(function () {
    function getLang() {
        if (window.Shopify && window.Shopify.locale) {
            return window.Shopify.locale.substring(0, 2);
        }
        return document.documentElement.lang ? document.documentElement.lang.substring(0, 2) : 'de';
    }

    const currentLang = getLang();

    if (currentLang === 'de') return;

    // Pre-sort keys by length (descending) to ensure longer phrases are translated first
    // This prevents "Gebetskette" from being translated inside "Suche eine Gebetskette aus"
    const sortedKeys = Object.keys(ZeptoTranslations).sort((a, b) => b.length - a.length);

    function translateText(text) {
        if (!text) return null;
        let newText = text;
        let modified = false;

        // Iterate through sorted keys
        for (const key of sortedKeys) {
            const map = ZeptoTranslations[key];
            const translation = map[currentLang];
            if (translation !== undefined && newText.includes(key)) {
                newText = newText.split(key).join(translation);
                modified = true;
            }
        }

        // INFINITE LOOP PROTECTION:
        // Only return if text actually changed from what it was
        if (modified && newText !== text) {
            return newText;
        }
        return null;
    }

    function walkAndTranslate(node) {
        // 1. Text Nodes
        if (node.nodeType === 3) {
            const original = node.nodeValue;
            if (original && /\S/.test(original)) {
                const translated = translateText(original);
                if (translated) {
                    node.nodeValue = translated;
                }
            }
        }
        // 2. Element Nodes
        else if (node.nodeType === 1) {
            if (['SCRIPT', 'STYLE', 'META', 'LINK'].includes(node.tagName)) return;

            // Handle Input Placeholders
            if (node.tagName === 'INPUT' || node.tagName === 'TEXTAREA') {
                if (node.placeholder) {
                    const transPlace = translateText(node.placeholder);
                    if (transPlace) node.placeholder = transPlace;
                }
            }

            // Recurse children
            Array.from(node.childNodes).forEach(walkAndTranslate);
        }
    }

    function hideFrenchSpecifics() {
        if (currentLang !== 'fr') return;

        // Selectors for elements to hide in French
        const selectorsToHide = [
            '.pplr-fge-ein-quranbuch-der-30-teil-hinzu--750', // Juz'Amma (Var 1)
            '.pplr-quran-mit-deutscher-bersetzung-30teil-750', // Juz'Amma (Var 2 - New)
            '.pplr-fge-ein-bittgebetbuch-hinzu-750',          // 200 Bittgebete (Var 1)
            '.pplr-200-bittgebete-buch-750'                   // 200 Bittgebete (Var 2)
        ];

        selectorsToHide.forEach(selector => {
            const wrappers = document.querySelectorAll(selector);
            wrappers.forEach(wrapper => {
                // 1. Hide the wrapper
                wrapper.style.display = 'none';

                // 2. Force select "Nicht Inklusive" / "Non inclus" default option
                // Find the swatch/option that has value "Nicht Inklusive" or corresponds to price 0
                const notIncludedOption = wrapper.querySelector('.pplr-swatch-element[data-val="Nicht Inklusive"], .pplr-swatch-element[data-pplr_price="0"]');

                if (notIncludedOption) {
                    // Simulate click to ensure Zepto logic registers it (removes price)
                    notIncludedOption.click();
                }
            });
        });
    }

    function runTranslation() {
        const personalizer = document.querySelector('.product-personalizer');
        if (personalizer) {
            // 1. Hide/Manage French specifics FIRST (Before translation)
            hideFrenchSpecifics();
            // 2. Then Translate
            walkAndTranslate(personalizer);
        } else {
            walkAndTranslate(document.body);
        }
    }

    // --- TRIGGER ---
    window.addEventListener('pplrAppInitiated', function () {
        runTranslation();

        const personalizer = document.querySelector('.product-personalizer');
        if (personalizer) {
            // Initial check
            hideFrenchSpecifics();

            new MutationObserver((mutations) => {
                // Always ensure specific fields are hidden/managed first upon any mutation
                hideFrenchSpecifics();

                mutations.forEach(m => {
                    if (m.type === 'childList') m.addedNodes.forEach(walkAndTranslate);
                    if (m.type === 'characterData') walkAndTranslate(m.target);
                });
            }).observe(personalizer, { childList: true, subtree: true, characterData: true });
        }
    });

    window.addEventListener('load', function () {
        if (document.querySelector('.product-personalizer')) {
            runTranslation();
        }
    });

})();
